export enum BankImportId {
  FIO_CZ = '2010',
  FIO_SK = '8330',
  KB = '0100',
  CS = '0800',
  CSOB = '0300',
  SLOVAK_SAVINGS_BANK = '0900',
  TATRABANK = '1100',
  UNICREDIT_CZ = '2700',
  ING_PL = 'INGB',
}
